import { handleSsoPopupCallback } from './embed/ssoPopupCallback'

// Trang nhúng /embed/* không dùng gì của clinicalApp: gán sẵn container rỗng để
// safeRemote dùng luôn, bỏ việc nạp + khởi tạo remote (kéo theo cả apps/x-crm) —
// trước đây làm trang nhúng chờ hết timeout 3 giây mới chạy.
if (window.location.pathname.startsWith('/embed/')) {
  // Iframe phủ toàn màn hình omnichannel: nền trong suốt ngay từ đầu, không chớp
  // trắng trong lúc bootstrap.min.css (nền body trắng) đã nạp mà embed.css chưa tới
  document.documentElement.style.setProperty('background', 'transparent', 'important')
  document.body.style.setProperty('background', 'transparent', 'important')
  ;(window as any).clinicalApp = {
    get: () => Promise.resolve(() => ({ __esModule: true, default: () => null })),
    init: () => {},
  }
}

// Popup đăng nhập SSO của trang nhúng /embed/booking: chỉ chuyển code về iframe,
// không bootstrap app (tránh AppShell/AuthInit tiêu thụ mất authorization code).
if (!handleSsoPopupCallback()) {
  // Async import để Module Federation hoạt động đúng (tránh eager loading)
  import('./bootstrap')
}

export {}
